import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=bf8a5c76&scoped=true&"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./BaseAutocomplete.vue?vue&type=style&index=0&id=bf8a5c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8a5c76",
  null
  
)

export default component.exports